import styles from "./FeedbackWithReply.module.scss";

const feedbackData = [
  {
    rating: 5,
    feedbackText:
      "Eine professionelle und fürsorgliche Werkstatt, die immer bereit ist, bei der Reparatur und Wartung von Automatikgetrieben zu helfen. Erfahrene Fachleute lösen alle Probleme schnell und zuverlässig, um eine schnelle und qualitativ hochwertige Serviceleistung zu gewährleisten. Ohne Zweifel empfehle ich diese Werkstatt allen Autofahrern!",
    name: "Dmitriy KDM",
    date: "April 23, 2025",
    replyText:
      "Vielen Dank für Ihre herzlichen Worte und Ihre Empfehlung! Es freut uns sehr, dass Sie mit unserem Service und der Arbeit unserer Fachleute zufrieden sind. Ihre Zufriedenheit ist unser größter Ansporn. Wir freuen uns darauf, Ihnen auch in Zukunft weiterhelfen zu dürfen!",
  },
  {
    rating: 5,
    feedbackText:
      "Ein DSG Service nach meiner Vorstellung! Sehr kompetente und freundliche Mitarbeiter. Besonders freundlich und zuvorkommend mit viel Fachwissen, Hilfsbereitschaft und Zuverlässigkeit kam mir Herr Pavel bei meinen Anliegen entgegen. Ich kann DSG Getriebeservice Hixa uneingeschränkt empfehlen!",
    name: "Uwe Fischer",
    date: "April 23, 2025",
    replyText:
      "Vielen Dank für Ihr großartiges Feedback! Es freut uns sehr, dass Sie mit unserem Service und besonders mit Herrn Pavel zufrieden waren. Ihre Empfehlung bedeutet uns viel und motiviert uns, weiterhin erstklassige Arbeit zu leisten. Wir freuen uns darauf, Sie auch in Zukunft unterstützen zu dürfen!",
  },
  {
    rating: 5,
    feedbackText:
      "Alles ist super zu empfehlen, sehr schnell das Problem gelöst, echte Alles ist super zu empfehlen, sehr schnell das Problem gelöst, echte Profis!",
    name: "EXCHANGE WORK",
    date: "April 23, 2025",
    replyText: "Immer gerne!",
  },
  {
    rating: 5,
    feedbackText: `Hixa UG hat meine DSG-Mechatronik angekauft. Guter Kontakt und gut erreichbar. Die Geschäftsführerin und Mitarbeiter sind wirklich sehr freundlich, auch als ich im Ton berechtigterweise etwas rauer geworden bin. Das erlebe ich selten, dass Unternehmen dann freundlich bleiben. Es gab leider nur unnötige Verzögerungen bei der Auszahlung und Abmachungen wurden nicht so eingehalten wie abgesMehr anzeigen Atila Alvin Beck`,
    name: "Atila Alvin Beck",
    date: "April 23, 2025",
    replyText:
      "Vielen Dank für Ihr ehrliches Feedback und Ihre konstruktive Kritik! Es freut uns, dass Sie unsere Freundlichkeit und Erreichbarkeit geschätzt haben, auch in anspruchsvolleren Momenten. Wir entschuldigen uns für die Verzögerungen und arbeiten kontinuierlich daran, unsere Prozesse zu verbessern. Vielen Dank für Ihre Anmerkungen – wir nehmen diese sehr ernst und hoffen, Sie in Zukunft wieder... Mehr anzeigen",
  },
  {
    rating: 5,
    feedbackText:
      "Thanks you very much all is Works, good work and staff, my DSG od working perfect",
    name: "Dario Matanovic",
    date: "Januar 24, 2025",
    replyText: "Danke für Bewertung. Immer gerne!",
  },
  // Add more feedback objects here...
];

const FeedbackWithReply = () => {
  return (
    <div className="container">
      <div className="sectionContainer sectionContainerWhite">
        {feedbackData.map((feedback, index) => (
          <div key={index} className={styles.feedback}>
            <div className={styles.rating}>
              {[1, 2, 3, 4, 5].map((_, index) => (
                <img
                  key={index}
                  src={
                    index + 1 <= feedback.rating
                      ? "/images/star-full.svg"
                      : "/images/star-empty.svg"
                  }
                  alt={`star-${index + 1}`}
                  className={styles.star}
                />
              ))}
              <p className={styles.date}>{feedback.date}</p>
            </div>

            <p className={styles.feedbackText}>{feedback.feedbackText}</p>
            <p className={styles.name}>{feedback.name}</p>

            <div className={styles.replyContainer}>
              <div className={styles.replyHeader}>
                <span className={styles.replyText}>
                  Antwort von HIXA – DSG Getriebe Reparatur & Wartung
                </span>
              </div>
              <div className={styles.reply}>
                <p>{feedback.replyText}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeedbackWithReply;
